import Backbone from 'backbone'
import template from './finder.hbs'
import _ from 'lodash'
import KeyCodes from 'scoreboard/components/key-codes'

var Finder = Backbone.View.extend({

	// this.options.type is either 'dim' or 'dark' (optional)
	// this.options.autofocus sets the finder to be autofocused if desired

	className: 'finder',

	events: {
		'keyup input': '_onKeyup',
		'keypress input': '_onKeypress'
	},

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.$('input').prop('autofocus', _.result(this.options, 'autofocus'))
		this.$el.addClass('finder-' + _.result(this.options, 'type'))
		this.previousText = this.text()
		this.delegateEvents()
		return this
	},

	// clear the search input the user previously typed in
	clear: function() {
		this.previousText = null
		this.$('input').val('')
	},

	_onKeyup: function(e = {}) {
		if (e.keyCode === KeyCodes.ESC) {
			// clear the search
			this.clear()
		}
		this._setPreviousText(this.text())
	},

	_setPreviousText: function(newText) {
		// only fire an event if the text actually changes
		if (this.previousText != newText) {
			this.trigger('find', newText)
			this.previousText = newText
		}
	},

	_onKeypress: function(e) {
		if (e.keyCode === KeyCodes.ENTER) {
			// don't submit any forms the finder may be in.  originally added
			// for admin | users
			e.preventDefault()
			e.stopPropagation()
		}
	},

	// If text is provided, set the input to reflect that text. If no text is provided,
	// return the text currently typed into the finder, or null if nothing
	// is typed in.
	text: function(text) {
		if (text) {
			this.$('input').val(text)
			this._setPreviousText(text)
		} else {
			var val = this.$('input').val()
			return _.isEmpty(val) ? null : val
		}
	},

	context: function() {
		return _.extend({}, this.options)
	}

})

export default Finder

Finder.__filename__ = 'components/finder.js'
